<template>
  <div class="mainInputField">
    <label v-if="label">{{ label }}</label>
    <div class="detailFileInputBox">
      <input class="upload-name" disabled="disabled" :value="value" />
      <span class="btn-main disabled" v-if="btnText">{{ btnText }}</span>
      <input
          type="file"
          id="input-files"
          class="upload-hidden"
          :accept="accept"
          @change="change"
          v-if="!disabled"
          multiple
      />
    </div>
    <div v-if="errors" class="helperError">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  name: "InputField",
  components: {},
  props: {
    errors: null,
    value: String,
    btnText: String,
    label: String,
    change: Function,
    accept: null,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
